<template>
  <div class="foot-hd w1200 ub ub-xc ub-ab">
    <div>
      <p>版权所有：龙岩市中医院</p>
      <p>医院地址：福建省龙岩市新罗区龙腾中路59号</p>
      <p>邮政编码：364000</p>
      <p>备案编号：闽ICP备15019899号-1</p>
      <p><img src="../../images/garz.png"  style="display: inline-block;vertical-align: middle; margin-right: 5px"/>闽公网安备 35080202351358号</p>
    </div>

    <div>
      <img src="../../images/zyy/sydw.png" alt="">
    </div>
    <div class="footr">
      <p>咨询电话：2890160（班内）  2881989（班外）</p>
      <p>邮箱：lyszyybrfwzx@126.com</p>
      <p>院务公开意见邮箱：szyybgs@126.com</p>
      <p>院长接待日：每周二下午（门诊七楼接待室）</p>
    </div>
  </div>
</template>

<script>
  export default {
    name: "tFoot",
    data() {
        return {
            footer: []
        }
    },
    mounted() {
      let base_info = this.getState('baseInfo');
      if(base_info!=null){
          this.footer = base_info.info;
      }
    }
  }
</script>

<style lang="scss">
.foot-hd{
  background: url("../../images/zyy/footbg.png") no-repeat;
  background-size: 100%;
  height: 200px;
  box-sizing: border-box;
  padding: 0 210px;
  p{
    color: #fff;
    font-size: 14px;
  }
  .footr{
    p{
      font-size: 14px;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/layout/foot.vue